import { Component, ElementRef, OnInit } from '@angular/core';
import { ApiService } from '../core/services';

@Component({
  selector: 'amber-barrier-location',
  template: require('./amber-barrier-location.component.html'),
  styles: [require('./amber-barrier-location.component.scss')]
})
export class AmberBarrierLocationComponent implements OnInit {
  lat: number;
  lng: number;
  id: number;
  record: any;
  showSpamButton = false;
  showSpamReport = false;
  showForm = false;
  hasSubmittedDownloadDetails = false;

  reported = false;

  constructor(elem: ElementRef, private api: ApiService) {
    this.lat = parseFloat(elem.nativeElement.getAttribute('lat'));
    this.lng = parseFloat(elem.nativeElement.getAttribute('lng'));
    this.id = parseFloat(elem.nativeElement.getAttribute('recordId'));
    try { // record data is passed as base64 encoded json
      this.record = JSON.parse(atob(elem.nativeElement.getAttribute('recordjson')));
    } catch (e) {
      console.log('unable to pass record data');
    }
    this.hasSubmittedDownloadDetails = localStorage.getItem('amber-download-cookie') !== null;
  }

  ngOnInit() {
    document.body.addEventListener('downloadSubscribe', () => {
      this.hasSubmittedDownloadDetails = true;
      this.showForm = false;
      this.downloadRecord();
    });
  }

  downloadRecord() {
    if (!this.record || !this.record.id) {
      return;
    }
    if (!this.hasSubmittedDownloadDetails && !this.showForm) {
      this.showForm = true;
      return;
    }

    const headers = ['id', 'lat', 'lng'];
    const row = [];

    row.push(this.record.id, this.record.lat, this.record.lng);

    for (const path of Object.keys(this.record.data)) {
      headers.push(path);
      row.push(this.record.data[path]);
    }

    const csv = headers.join(',') + '\n' + row.join(',');

    if (window.Blob === undefined || window.URL === undefined || window.URL.createObjectURL === undefined) {
      alert('Your browser doesn\'t support Blobs');
      return;
    }

    const file = new Blob([csv], { type: 'text/csv' });
    const link = document.createElement('a');
    link.download = 'record_' + this.record.id + '.csv';
    link.href = window.URL.createObjectURL(file);
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
  }

  report() {
    if (!this.reported) {
      this.reported = true;
      this.cancelReport();
      this.api.classifySpam(this.id).subscribe();
    }
  }

  showSpamReportMessage() {
    this.showSpamReport = true;
    this.showSpamButton = false;
  }

  cancelReport() {
    this.showSpamReport = false;
    this.showSpamButton = true;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/amber-barrier-location/amber-barrier-location.component.ts